import {
  ACCOUNT_EXTRA_DETAILS_PATH,
  BACKTESTING_EXTRA_DETAILS_PATH,
  BOT_EXTRA_DETAILS_PATH,
  COIN_EXTRA_DETAILS_PATH,
  GROUP_CONFIGURATION_PATH,
  MARKETPLACE_GROUP_PATH,
  QUICK_ONBOARDING_PATH,
  SIGNAL_EXTRA_DETAILS_PATH,
  TRADE_EXTRA_DETAILS_PATH,
} from "common/constants.ts";
import React, { useMemo, useState } from "react";
import useRoutesMatch from "utils/hooks/useRoutesMatch.ts";
import { lazyLoad } from "utils/lazyLoad.tsx";
import AssetDrawer from "features/portfolio/CoinDrawer/AssetDrawer.tsx";
import BotDrawer from "features/bots/BotDrawer/BotDrawer.tsx";
import AccountDrawer from "features/portfolio/AccountDrawer/AccountDrawer.tsx";
import GroupConfigurationDrawer from "features/configuration/GroupConfigurationDrawer/GroupConfigurationDrawer.tsx";
import SignalDrawer from "features/signals/SignalDrawer/SignalDrawer.tsx";
import GroupDrawer from "features/newMarketplace/GroupExtraDetails/GroupDrawer.tsx";
import BacktestingDrawer from "features/bots/BotForm/Backtesting/ExtraDetailsDrawer/BacktestingDrawer.tsx";
import TradeDrawer from "features/trades/TradeDrawer/TradeDrawer.tsx";

const QuickOnboarding = lazyLoad(
  () => import("features/quickOnboarding/QuickOnboarding.tsx")
);

const useDrawers = () => {
  const drawers = useMemo(() => Object.values(PATH_TO_DRAWER), []);
  const [visitedIndices, setVisitedIndices] = useState<boolean[]>(
    Array(DRAWER_PATHS.length).fill(false)
  );
  const currentMatch = useRoutesMatch(DRAWER_PATHS)?.[0];
  const isDrawer = !!currentMatch;

  return {
    paths: DRAWER_PATHS,
    drawers,
    visitedIndices,
    setVisitedIndices,
    currentMatch,
    isDrawer,
  };
};

export default useDrawers;

const PATH_TO_DRAWER = {
  [COIN_EXTRA_DETAILS_PATH]: <AssetDrawer key="assetDrawer" />,
  [BOT_EXTRA_DETAILS_PATH]: <BotDrawer key="botDrawer" />,
  [ACCOUNT_EXTRA_DETAILS_PATH]: <AccountDrawer key="accountDrawer" />,
  [GROUP_CONFIGURATION_PATH]: (
    <GroupConfigurationDrawer key="groupConfigurationDrawer" />
  ),
  [SIGNAL_EXTRA_DETAILS_PATH]: <SignalDrawer key="signalDrawer" />,
  [MARKETPLACE_GROUP_PATH]: <GroupDrawer key="groupDrawer" />,
  [BACKTESTING_EXTRA_DETAILS_PATH]: (
    <BacktestingDrawer key="backtestingDrawer" />
  ),
  [TRADE_EXTRA_DETAILS_PATH]: <TradeDrawer key="tradeDrawer" />,
  [QUICK_ONBOARDING_PATH]: <QuickOnboarding />,
};

export const DRAWER_PATHS = Object.keys(PATH_TO_DRAWER);
